<template>
    <td class="compare-table__column--product-left">
        <div class="location" v-if="hasLocation && available > 0">
            <div class="block-space block-space--layout--divider-order-entry"></div>
            <div class="availability-product-ording">
                <div class="text-compare-item-available"><font class="text-compare-item-available">Available: {{ available }}</font></div>
                <!-- <div class="text-compare-item-available"><font class="text-compare-item-available">Rank: {{location.rank}}</font></div> -->
                <div class="text-compare-item-available"><font class="text-compare-item-available"></font></div>
                <div class="compare-table--add-to-cart">
                    <table>
                        <tr class="compare-table--add-to-cart">
                            <td class="compare-table--add-to-cart-selector">
                                <base-quantity-input v-model="quantity"></base-quantity-input>
                            </td>
                            <td class="compare-table--add-to-cart-button">
                                <button type="button" class="btn btn-xs btn-checkout" :disabled="AddtoCartEnable" @click="addToCart">Add to Cart</button>
                            </td> 
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </td>
</template>

<script>
import MixinCart from '../../../mixins/cart.js';

export default {
    data() {
        return {
            quantity: 1,
            btnAddEnable: 'disabled',
        }
    },
    mixins : [
        MixinCart
    ],
    props : {
        location : {
            type: Object,
        },
        address : {
            type: String,
        },
        availability : {
            type: String,
        },
        rank : {
            type: String,
        },
        location_id: {
            
        },
        product: {
            type: Object
        }
    },
    computed : {
        AddtoCartEnable(){
            const row_loc = this.location.find(loc => loc.location_id == this.location_id);
            if(row_loc.stockquantity > 0){
                return false;
            }else{
                return 'disabled';
            }
        },
        row_loc() {
            return this.location.find(loc => loc.location_id == this.location_id);
        },

        hasLocation() {
            return (this.location !== null);
        },
        available(){
            const row_loc = this.location.find(loc => loc.location_id == this.location_id);
            return row_loc.stockquantity;
        },
    },
    methods: {
        addToCart() {
            // console.log(this.product);

            // this.$store.dispatch("message/clearKeyedMessage", this.sourcePage);
            let linetotal = 0;
            const loc = this.location.find(loc => loc.location_id == this.location_id);
            const wd_mdfgs = this.$store.getters.wd_mfgs;
            const clearProductDesc = encodeURIComponent(this.product.name);

            linetotal = this.quantity * this.product.yourprice;

            let productData = {
                ID: this.product.ID,
                item: this.product.ID,
                desc: this.product.name,
                manufacturer: this.product.manufacturer,
                image: this.product.image,
                quantity: this.quantity,
                listprice: this.product.listprice,
                corecharge: this.product.corecharge,
                yourprice: this.product.yourprice,
                shipping: 0,
                linetotal: linetotal,

                mfgSeo: wd_mdfgs.find(w => w.MFG_CODE == this.product.manufacturer).SEO,
                itemSeo: clearProductDesc.replace(/ /g, "-"),

                stockquantity: loc.stockquantity,
                locationid: loc.location_id,
                locationname: loc.location,
                locationcity: loc.city,
                locationstate: loc.state,

                // new fields
                XRMFGC: this.product.XRMFGC,
                XRITMC: this.product.XRITMC,
                IMIGSA: this.product.IMIGSA,
                IMISVALID: this.product.IMISVALID,
            }

            let validationresult = this.addToCartValidation(productData);

            if (validationresult.status === 'OK') {
                // console.log(productData);
                this.$store.dispatch("cart/addToCart", productData);
            }
        }
    },
    created(){
        // console.log('location id = ' + this.location_id);
    }
}
</script>